import ApiService from "@/services/api.service";
import {log} from "@emons/emons-vue"
import {addConstraints} from "@/services/notificationCode.service";

const rel = 'addresses'
const path = '/api/addresses';
const schema = {
    isRetail: false,
    customerId: null,
    name: null,
    additionalName: null,
    street: null,
    zipCode: null,
    city: null,
    country: null,
    contactName: null,
    isDefault: null,
    isNeutral: null,
    mobile: null,
    email: null,
    phone: null,
    web: null,
    deliveryNotes: []
}
const header = {
    isDefaultSenderAddress: {
        name: 'address.defaultSenderAddress',
        col: 'col-1',
        property: 'isDefaultSenderAddress',
        formatter: function (val) {
            return !!val?'Ja':'Nein'
        }
    },
    customerId: {
        name: 'address.customerId',
        col: 'col-1',
        property: 'customerId'
    },
    name: {
        name: 'address.name',
        col: 'col-3',
        property: 'name'
    },
    street: {
        name: 'address.street',
        col: 'col-2',
        property: 'street'
    },
    country: {
        name: 'address.country',
        col: 'col-1',
        property: 'country'
    },
    zipCode: {
        name: 'address.zipCode',
        col: 'col-1',
        property: 'zipCode'
    },
    city: {
        name: 'address.city',
        col: 'col-2',
        property: 'city'
    }
}
const filterType = 'button-group';
const filter = {
    sender: {
        name: 'addressType.SENDER',
        type: 'SENDER',
        active: true
    },
    consignee: {
        name: 'addressType.CONSIGNEE',
        type: 'CONSIGNEE',
        active: true
    },
    loadingSite: {
        name: 'addressType.LOADING_SITE',
        type: 'LOADING_SITE',
        active: true
    },
    neutral: {
        name: 'addressType.NEUTRAL',
        type: 'NEUTRAL',
        active: true
    }
}
const sync = null
const initialSort = 'name'
const projection = 'list'
const create = true

const Service = {
    getHeader: function () {
        return header
    },
    getFilterType: function () {
        return filterType
    },
    getFilter: function () {
        return filter
    },
    getSync: function () {
        return sync
    },
    getCreate: function () {
        return create
    },
    getInitialSort: function () {
        return initialSort
    },
    getProjection: function () {
        return projection
    },
    find: async function (query,
                          filters,
                          projection,
                          sortProperty,
                          sortDirection,
                          size, page = 0) {
        try {
            return ApiService.get(path, {
                params: {
                    query: query,
                    type: Object
                        .values(filters)
                        .map((value, index) => {
                            if (value.active)
                                return value.type
                        })
                        .filter(x => x !== undefined)
                        .join(),
                    projection: projection,
                    sort: sortProperty + ',' + sortDirection,
                    size: size != null ? size : 100,
                    page: page
                },
                transformResponse: [function (data) {
                    if (data) {
                        let parsedData = JSON.parse(data)

                        if (parsedData) {

                            let response = {
                                links: parsedData['_links'],
                                page: parsedData['page'],
                                items: parsedData['_embedded'] && parsedData['_embedded'][rel]?parsedData['_embedded'][rel]:[]
                            };

                            response.items.forEach(item => {
                                ApiService.ensureSchema(schema, item)
                                addConstraints(item?.deliveryNotes)
                            })

                            log("debug", "find():", response)

                            return response
                        }
                    }
                }]
            })
        } catch (error) {
            log('error', 'Error querying ' + rel + ':', error)
        }
    },
    nextPage: async function (link) {
        try {
            return ApiService.get(link, {
                params: {},
                transformResponse: [function (data) {
                    if (data) {
                        let parsedData = JSON.parse(data)

                        if (parsedData) {
                            let response = {
                                links: parsedData['_links'],
                                page: parsedData['page'],
                                items: parsedData['_embedded'] && parsedData['_embedded'][rel]?parsedData['_embedded'][rel]:[]
                            };

                            response.items.forEach(item => {
                                ApiService.ensureSchema(schema, item)
                                addConstraints(item?.deliveryNotes)
                            })

                            log("debug", "nextPage():", response)

                            return response
                        }
                    }
                }]
            })
        } catch (error) {
            log("error", "Error on next page:", error)
        }
    },
    getEntityDetails: async function (link) {
        try {
            return ApiService.get(this.cleanLink(link), {
                params: {},
                transformResponse: [function (data) {
                    if (data) {
                        let parsedData = JSON.parse(data)
                        addConstraints(parsedData?.deliveryNotes)

                        log("debug", "getEntityDetails():", parsedData)

                        return parsedData
                    }
                }]
            })
        } catch (error) {
            log("error", "Error querying entity:", error)
        }
    },
    getDefaultSenderAddress: async function () {
        try {
            const response = await ApiService.get(path + "/defaultSender", {
                params: {},
                transformResponse: [function (data) {
                    if (data) {
                        let parsedData = JSON.parse(data)
                        addConstraints(parsedData?.deliveryNotes)

                        log("debug", "getDefaultSender():", parsedData)

                        return parsedData
                    }
                }]
            })
            return response.data
        } catch (error) {
            if (404 == error.response?.status) {
                log('debug', 'default sender not found')
            } else {
                log("error", "Error querying default sender:", error)
            }
        }
    },
    getDefaultConsigneeAddress: async function () {
        try {
            const response = await ApiService.get(path + "/defaultConsignee", {
                params: {},
                transformResponse: [function (data) {
                    if (data) {
                        let parsedData = JSON.parse(data)
                        addConstraints(parsedData?.deliveryNotes)

                        log("debug", "getDefaultConsignee():", parsedData)

                        return parsedData
                    }
                }]
            })
            return response.data
        } catch (error) {
            if (404 == error.response?.status) {
                log('debug', 'default consignee not found')
            } else {
                log("error", "Error querying default consignee:", error)
            }
        }
    },
    save: async function (entity, pathForCreate = null) {
        if (entity._links && entity._links.self)
            return ApiService.put(this.cleanLink(entity._links.self.href), entity).then(
                response => {
                    if (response.data) {
                        ApiService.ensureSchema(schema, response.data)
                        addConstraints(response.data?.deliveryNotes)
                    }

                    return response
                })
        else {
            return ApiService.post(!!pathForCreate ? pathForCreate : path, entity).then(
                response => {
                    if (response.data) {
                        ApiService.ensureSchema(schema, response.data)
                        addConstraints(response.data?.deliveryNotes)
                    }

                    return response
                })
        }
    },
    delete: async function (entity) {
        if (entity._links && entity._links.self) {
            return ApiService.delete(this.cleanLink(entity._links.self.href))
        }
    },
    create: function () {
        log('debug', 'create() called...')
        return {
            isOpen: true,
            changed: true,
            isDefault: false,
            isNeutral: false,
            country: 'DE',
            deliveryNotes: []
        };
    },
    cleanLink: function (link) {
        if (link) {
            if (link.indexOf('{') > -1)
                link = link.split('{')[0];

            if (link.indexOf('?') > -1)
                link = link.split('?')[0];

            return link;
        } else
            return link;
    }
}

export default Service